import React from 'react';
import { Carousel } from 'antd';
import Link from '../Link';

const MyCarousel = ({ data, mod, ...props }) => {
  return (
    <Carousel {...props}>
      {
        data.map((item, index) => {
          return (
            <Link
              href={item.link_url}
              link_type={item.link_type}
              link_page_type={item.link_page_type}
              link_page_id={item.link_page_id}
              link_page_param={item.link_page_param}
              key={index}>
              <img src={item.img_url} />
            </Link>
          )
        })
      }
    </Carousel>
  )
}

export default MyCarousel;